module.exports = __webpack_public_path__ + "static/img/6.63e236d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/sp/6.png
// module id = XM88
// module chunks = 0